import { render, staticRenderFns } from "./statistical-analysis-skeleton-incident-dossier-widgets.vue?vue&type=template&id=0413f54e&scoped=true&"
import script from "./statistical-analysis-skeleton-incident-dossier-widgets.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-skeleton-incident-dossier-widgets.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-skeleton-incident-dossier-widgets.scss?vue&type=style&index=0&id=0413f54e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0413f54e",
  null
  
)

export default component.exports